<sw-toolbar id="toolbar"></sw-toolbar>

<div id="canvas-container">
  <canvas id="fabric8-canvas" (mousewheel)="scrollWheel($event)"></canvas>
  <sw-contextmenu></sw-contextmenu>
</div>

<div id="nodes">
  <sw-objects-panel></sw-objects-panel>
</div>